/*
* @描述: 新增商机
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-06 09:25:36
*/
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               :modal-append-to-body="false"
               class="custom_form_dialog custom-form-dialog"
               title="新增商机"
               width="600px">
        <div v-loading="loading" class="custom_form_body">
            <CustomFormPc v-if="formInfoList.length"
                          :field_list="formInfoList"
                          ref="projectForm"
                          :field_form="'projects'"
                          @submit-form="submitProjectFormData"></CustomFormPc>
            <div class="add_approval_select_process">
                <approveProcessSelect ref="approveProcessSelectRef"
                                      :approval_node_list="approval_node_list">
                </approveProcessSelect>
            </div>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button :disabled="btnDisabled" plain type="primary" @click="handleDialogSave">保存</el-button>
            <el-button :disabled="btnDisabled" type="primary" @click="handleDialogConfirm">发布</el-button>
        </div>
    </el-dialog>
</template>
<script>
import CustomFormPc from "@/components/pComponents/CustomFormPc.vue"
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import {getApprovalNodes, getFormFields, projectAdd} from "@/api";
import {getBusinessIsApproval} from "@/utils";

export default {
    name: "BusinessAdd",
    data() {
        return {
            loading: false,
            formInfoList: [],
            projectFormData: {},
            projectStageId: 0,
            isApproval: 0,
            is_release: 1,
            approval_node_list: [],
            btnDisabled: false,
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
    },
    components: {CustomFormPc, approveProcessSelect},
    created() {
        this._getFromFields()
    },
    methods: {
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'projects'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    getBusinessIsApproval('project_add').then(res => {
                        this.isApproval = res
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'project_add',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.approval_node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        } else {
                            this.loading = false
                        }
                    })
                } else {
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取商机表单数据
        submitProjectFormData(data) {
            this.projectFormData = {
                ...data,
                is_release: this.is_release,
                node_list: this.approval_node_list
            }
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.btnDisabled = true
            projectAdd(this.projectFormData).then(res => {
                if (res.code === 200) {
                    this.$message.success('添加成功')
                    this.$emit('update:dialogVisible', false)
                    this.$emit('refresh-list')
                } else {
                    this.btnDisabled = true
                }
            })
        },

        //保存
        handleDialogSave() {
            this.is_release = 0
            this.$refs.projectForm.handleClickPublish(false)
        },

        // 确定
        handleDialogConfirm() {
            this.is_release = 1
            this.$refs.projectForm.handleClickPublish()
        },
    },
}
</script>
<style lang="scss" scoped>
.custom_form_body {
    max-height: 490px;
    padding: 24px;
}
</style>